import { useHudStore } from "../store/hudStore";
import { Button, Card } from "../design-system/components";
import s from "./Auth.module.css";

// Shown while config/data load (mirrors app.html screenLoading).
export default function Loading() {
  const error = useHudStore((st) => st.startupError);
  const boot = useHudStore((st) => st.boot);
  return (
    <main className={s.overlay} aria-label={error ? "Life OS could not load" : "Life OS is loading"} aria-busy={!error}>
      {error ? (
        <Card className={s.card}>
          <div className={s.brand}>
            <span className={s.logo}><img src="/logo.png" alt="" /></span>
            <h1 className={s.title}>Couldn't load Life OS</h1>
          </div>
          <p className={s.startupError} role="alert">{error}</p>
          <Button variant="primary" icon="fa-solid fa-arrow-rotate-right" onClick={() => void boot()} autoFocus>Try again</Button>
        </Card>
      ) : (
        <div className={s.loadingInner} role="status" aria-live="polite">
          <span className={s.logo}>
            <img src="/logo.png" alt="" />
          </span>
          <i className={`fa-solid fa-spinner ${s.spinner}`} aria-hidden="true" />
          <p className={s.loadingText}>Loading your Life OS…</p>
        </div>
      )}
    </main>
  );
}
